import {
  Sheet,
  SheetContent,
  SheetTrigger,
} from "@/components/ui/sheet";
import { useCartStore, selectTotalItems, selectTotalPrice, selectCurrency } from "@/stores/cart";
import { useUIStore } from "@/stores/ui";
import { CartTriggerButton } from "./CartTriggerButton";
import { CartHeader } from "./CartHeader";
import { EmptyCart } from "./EmptyCart";
import { CartItemsList } from "./CartItemsList";
import { CartFooter } from "./CartFooter";
import { handleError } from "@/lib/error-handling";

export const CartDrawer = () => {
  const { isCartOpen, setCartOpen } = useUIStore();
  const { 
    items, 
    checkoutState,
    updateQuantity, 
    removeItem, 
    createCheckout 
  } = useCartStore();
  
  const totalItems = selectTotalItems(items);
  const totalPrice = selectTotalPrice(items);
  const currencyCode = selectCurrency(items);

  const handleCheckout = async () => {
    try {
      await createCheckout();
      const checkoutUrl = useCartStore.getState().checkoutUrl;
      if (checkoutUrl) {
        window.open(checkoutUrl, '_blank');
        setCartOpen(false);
      }
    } catch (error) {
      handleError('Checkout', error, {
        userMessage: 'Checkout failed',
        description: 'Please try again or contact support if the problem persists.',
      });
    }
  };

  const isLoading = checkoutState.status === 'loading';
  const isDisabled = items.length === 0 || isLoading;

  return (
    <Sheet open={isCartOpen} onOpenChange={setCartOpen}>
      <SheetTrigger asChild>
        <CartTriggerButton totalItems={totalItems} />
      </SheetTrigger>
      
      <SheetContent className="w-full sm:max-w-lg flex flex-col h-full bg-background border-l border-border/50">
        <CartHeader totalItems={totalItems} />
        
        <div className="flex flex-col flex-1 pt-6 min-h-0">
          {items.length === 0 ? (
            <EmptyCart />
          ) : (
            <>
              <CartItemsList 
                items={items}
                onUpdateQuantity={updateQuantity}
                onRemove={removeItem}
              />
              
              <CartFooter
                totalPrice={totalPrice}
                currencyCode={currencyCode}
                isLoading={isLoading}
                isDisabled={isDisabled}
                onCheckout={handleCheckout}
              />
            </>
          )}
        </div>
      </SheetContent>
    </Sheet>
  );
};
